export { default } from './IndexSecondView';



// WEBPACK FOOTER //
// ./src/components/IndexSecondView/index.js